<!-- src/components/GlobalDialog.vue -->
<template>
  <v-dialog
    v-model="store.open"
    :persistent="store.persistent"
    max-width="420"
    @keydown.esc.stop="store._onEsc"
  >
    <v-card class="rounded-xl">
      <v-card-title class="py-4">
        <div class="flex items-center gap-3">
          <v-avatar size="28" :color="tone.color" variant="tonal">
            <component :is="tone.icon" size="18" />
          </v-avatar>
          <span class="text-h6">{{ store.title }}</span>
        </div>
      </v-card-title>

      <v-card-text class="pb-0">
        <div class="text-body-2 whitespace-pre-line">
          {{ store.message }}
        </div>
      </v-card-text>

      <v-divider class="my-4" />

      <v-card-actions class="justify-end gap-2 pb-4 px-4">
        <template v-for="key in store.buttonList" :key="key">
          <v-btn
            :variant="key === store.primaryAction ? 'flat' : 'text'"
            :color="key === store.primaryAction ? tone.color : undefined"
            :autofocus="key === store.primaryAction"
            @click="store._resolve(key)"
          >
            {{ labels[key] }}
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
// Minimal icon set using Vuetify's built-ins (or replace with your own).
import { computed } from "vue"; // ✅ Add this
import { useDialogStore } from "@/stores/dialog";
const store = useDialogStore();

const labels = {
  ok: "OK",
  cancel: "Cancel",
  yes: "Yes",
  no: "No",
};

const toneMap = {
  info:   { color: "primary", icon: "v-icon" },
  success:{ color: "success", icon: "v-icon" },
  warn:   { color: "warning", icon: "v-icon" },
  error:  { color: "error",   icon: "v-icon" },
};

// Tiny adapter so we can show different icons per variant.
// If you use Material Design Icons, swap to <v-icon>mdi-*</v-icon>.
const tone = computed(() => {
  const t = toneMap[store.variant] ?? toneMap.info;
  return {
    color: t.color,
    icon: {
      // lightweight inline components using <v-icon> to avoid extra deps
      props: ['size'],
      template: `<v-icon :size="size">
        {{ iconName }}
      </v-icon>`,
      computed: {
        iconName() {
          switch (store.variant) {
            case "success": return "mdi-check-circle-outline";
            case "warn":    return "mdi-alert-outline";
            case "error":   return "mdi-alert-circle-outline";
            default:        return "mdi-information-outline";
          }
        }
      }
    }
  };
});
</script>

<style scoped>
.flex { display: flex; }
.items-center { align-items: center; }
.gap-3 { gap: .75rem; }
.whitespace-pre-line { white-space: pre-line; }
</style>
